import React, {useEffect, useState} from 'react'
import historyIcon from '../imgs/history.png'
import preplanIcon from '../imgs/preplan.png'
import {ApiService} from "../api/ApiService";
import {LoadInfo} from "../api/model/LoadInfo";
import {Link} from "react-router-dom";
import {UserState, userStore} from "../api/AuthService";
import { createGesture, IonContent, IonFooter, IonHeader, IonPage, IonToolbar, Gesture } from "@ionic/react";
import Nav from './Nav';
import Toolbar from './Toolbar';
import { sidnavStore, SidenavState } from "../api/SidenavStore";

const Load = () => {

	const [hasPrePlanned, setHasPrePlanned] = useState(false)
    const [scarcityMode, setScarcityMode] = useState('0');
    const {load}: { load: LoadInfo } = userStore((state: UserState) => ({load: state.loadInfo}));
    const {open, close}: { open: boolean, close: () => void } = sidnavStore((state: SidenavState) => ({open: state.open, close: state.close}));
    const {toggleSidenav}: { toggleSidenav: () => void } = sidnavStore((state: SidenavState) => ({toggleSidenav: state.toggle}));

    const ref = React.useRef<HTMLInputElement>(null)

	useEffect(() => {
		ApiService.getUserState('Load', {name: 'scarcityMode', userId: 0}).then(it => setScarcityMode(it.value));
        ApiService.getPreplannedLoads('load').then(it => setHasPrePlanned(!!it?.length)).catch(it => console.log("no preplanneds found"))
        gestureInit();
    }, [])

    const gestureInit = () => {
        const card = ref.current
        if (card) {
            const gesture = createGesture({
                el: card,
                gestureName: 'swipeMenu',
                onMove: (detail) => {
                    console.log("moving");
                },
                onEnd: (detail) => {
                    console.log("move ended");
                    toggleSidenav();
                }                 
            })
            gesture.enable();
        }
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="primary">
                    <Toolbar pageName="Load"/>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen color="light">
                <div ref={ref} onClick={() => close()} style={{height: "80vh"}}>
                    <div className='item-container'>
                        <div className="grid50">
                            {scarcityMode === '0' && hasPrePlanned ?
                                <Link to="/preplanned" className="western-button-link">
                                    <div className="loading-div" id="centered">
                                        <p style={{margin: "30% 0"}}>Preplanned</p>
                                    </div>
                                </Link>
                                :
                                <Link to="/loadselection" className="western-button-link">
                                    <div className="loading-div" id="centered">
                                        <p style={{margin: "30% 0"}}>Load Selection</p>
                                    </div>
                                </Link>}
                            <div>
                                <Link to="/loadhistory" className="western-button-link">
                                    <div>
                                        <img src={historyIcon} alt="key" className="link-icon"/><p>Load History</p>
                                    </div>
                                </Link>
                                <Link to="/currentload" className="western-button-link">
                                    <div>
                                        <img src={preplanIcon} alt="key" className="link-icon"/><p>Current Load</p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>
            <IonFooter>
                <Nav pageName="Load"/>
            </IonFooter>
        </IonPage>
    )
}

export default Load
